import React, { Dispatch, FC, SetStateAction } from "react";
import { useOnChangeChildDispatch } from "utils/OnChange";
import { WidgetCarouselTheme } from "@xapp/intelligent-search-widget";
import { SearchWidgetCardThemeBuilder } from "./SearchWidgetCardThemeBuilder";

export interface SearchWidgetCarouselThemeBuilderProps {
    readonly theme: WidgetCarouselTheme | undefined;
    readonly defaultTheme: WidgetCarouselTheme | undefined;
    readonly onChange: Dispatch<SetStateAction<WidgetCarouselTheme>>;
}

const EMPTY_THEME: WidgetCarouselTheme = {};

const SearchWidgetCarouselThemeBuilderInner: FC<SearchWidgetCarouselThemeBuilderProps> = props => {
    const theme: WidgetCarouselTheme = props.theme ?? EMPTY_THEME;
    const defaultTheme: WidgetCarouselTheme = props.defaultTheme ?? EMPTY_THEME;

    const { onChange } = props;

    const handleCardChange = useOnChangeChildDispatch("card", onChange);

    return (
        <SearchWidgetCardThemeBuilder label="Carousel" theme={theme.card} defaultTheme={defaultTheme.card} onChange={handleCardChange} />
    );
};

export const SearchWidgetCarouselThemeBuilder = React.memo(SearchWidgetCarouselThemeBuilderInner);
